<template>
  <div class="btn-reservation-fixed d-lg-none" :class="{'full': phoneReservationPopup}">

    <div class="row px-3 hide">
      <div class="col-6 mt-1" @click="toggleReservationRightModal">
        <strong class="d-block" v-if="selectedPrice === null && accommodation.price_from != 9999">
          <span class="text-lowercase pe-1">{{ $t('from') }}</span>
          <span class="h4">{{ accommodation.price_from }}</span>
          {{ activeLocaleCurrency.mark }}/{{ $t('night') }}
          <meta itemprop="priceRange"
                :content="`${$i18n.t('from')} ${accommodation.price_from} ${activeLocaleCurrency.mark}/${$i18n.t('night')}`">
        </strong>
        <strong class="d-block" v-else-if="accommodation.price_from">{{ selectedPrice }}</strong>
        <small class="d-block"
               v-if="selectedDates === null || selectedDates.from === selectedDates.to">{{ $t('select-date') }}</small>
        <small class="d-block" v-else>{{ `${selectedDates.from} - ${selectedDates.to}` }}</small>
      </div>
      <div class="col-6 mt-2">
        <button class="btn btn-first rounded float-end" @click="toggleReservationRightModal">
          {{ $t('reserve') }}
        </button>
      </div>
    </div>


    <div class="content close-btn-reservation-mob">
      <div class="col text-center">
        <button class="btn btn-outline-first rounded mx-auto fw-normal"
                @click="toggleReservationRightModal">
          <TyIcon icon="ty-arrow-down" width=".8rem" height=".8rem"
                  class="px-0 icon-color-first close-icon me-2"/>
          {{ $t('close') }}
        </button>
      </div>
      <ReservationCard :accommodation="accommodation" :client="client" @onUpdateReservationData="setSelectedData"
                       @contactHostAction="emit('contactHostAction')"/>
    </div>


  </div>


</template>

<script setup lang="ts">
import {PropType, ref} from "vue";
import Accommodation from "../../../../../../lib/models/Accommodation";
import Client from "../../../../../../lib/models/Client";
import ReservationCard from "./acc_detail_right_reservation";
import dayjs from "dayjs";
import {useStateFunctionBodyClass} from "../../../../../../composables/state/body_class";
import {useNuxtApp} from "#app";
import {obtainActiveLocale, obtainActiveLocaleCurrency} from "../../../../../../composables/master_page";
import {GATracker} from "../../../../../../composables/ga_tracker";
import {switchCurrencyMark} from "../../../../../../lib/functions";

const props = defineProps({
  accommodation: Object as PropType<Accommodation>,
  client: Object as PropType<Client>
})

const emit = defineEmits(['contactHostAction']);

const {GATrackEvent} = GATracker();
const phoneReservationPopup = ref(false);
const selectedDates = ref<null | { from: string, to: string }>(null);
const selectedPrice = ref<null | string>(null);
const {$i18n} = useNuxtApp();
const activeLocale = obtainActiveLocale();
const activeLocaleCurrency = obtainActiveLocaleCurrency();

const {updateBodyClass, removeBodyClass} = useStateFunctionBodyClass();

const toggleReservationRightModal = () => {
  phoneReservationPopup.value = !phoneReservationPopup.value
  if (phoneReservationPopup.value) {
    updateBodyClass('no-scroll');

    GATrackEvent({
      event: 'reservation_button_bottom_phone',
      language: activeLocale.code,
      action: 'click',
      label: 'Phone bottom button for reservation',
      value: props.accommodation.link,
      items: [
        {
          item_id: props.accommodation.id,
          item_name: props.accommodation.title,
          item_category: props.accommodation.category,
          currency: activeLocaleCurrency.code,
          item_variant: props.accommodation.location.tourist_region.code
        }
      ]
    }, 0);


  } else {
    removeBodyClass('no-scroll');
  }
};

const setSelectedData = (data) => {
  if (data.arrivalDate && data.leaveDate) {
    selectedDates.value = {
      from: dayjs(data.arrivalDate).format('DD.MM.YYYY'),
      to: dayjs(data.leaveDate).format('DD.MM.YYYY')
    };
  } else {
    selectedDates.value = null;
  }
  if (!isNaN(data.totalPrice) && data.totalPrice > 0) {
    selectedPrice.value = data.totalPrice + ' ' + data.currency;
  }
}

const showReservation = () => {
  toggleReservationRightModal();
}


defineExpose({
  showReservation,
});


</script>
